import { TaggedInterface } from '@casl/ability/dist/types/types';

export const abilitySubjects = [
  'User',
  'Group',
  'Role',
  'AccessPoint',
  'Message',
  'Ticket',
  'Order',
  'Location',
  'LocationPermission',
  'Import',
  'ImportRowError',
  'Fttx',
  'ProvisioningSettings',
  'OLT',
  'ONT',
  'Email',
  'Autofind',
  'Attachment',
  'CommonOptions',
  'BillingSettings',
  'Report',
  'Problem',
  'CustomNotification',
  'Profilactic',
  'UserOption',
  'GroupNotificationsSettings',
  'NetworkTicket',
  'ProfilacticSettings',
  'Colocation',
  'ColocationSettings',
  'PredefinedText',
] as const;

export type AbilitySubjectType = (typeof abilitySubjects)[number];

export type RawAbilitySubjectType = AbilitySubjectType | 'all';

export type AbilitySubject =
  | AbilitySubjectType
  | TaggedInterface<AbilitySubjectType>;

export const abilitySubjectMap: Map<RawAbilitySubjectType, string> = new Map([
  ['all', 'Všetko'],
  ['User', 'Používatelia'],
  ['Group', 'Skupiny'],
  ['Role', 'Roly'],
  ['AccessPoint', 'Prístupové body'],
  ['Order', 'Objednávky'],
  ['Message', 'Správy'],
  ['Ticket', 'Ticket'],
  ['Location', 'Lokácie'],
  ['LocationPermission', 'Oprávnenia lokácií'],
  ['Fttx', 'ODB'],
  ['ProvisioningSettings', 'Nastavenia provisioningu'],
  ['OLT', 'OLT'],
  ['ONT', 'ONT'],
  ['Email', 'Email'],
  ['Autofind', 'Autofind'],
  ['CommonOptions', 'Všeobecné nastavenia'],
  ['BillingSettings', 'Nastavenia fakturácie'],
  ['Attachment', 'Prílohy'],
  ['Report', 'Reporty'],
  ['Problem', 'Problémy'],
  ['CustomNotification', 'Vlastné notifikácie'],
  ['UserOption', 'Nastavenia používateľa'],
  ['Profilactic', 'Servisná profylaktika'],
  ['GroupNotificationsSettings', 'Nastavenia notifikácií skupiny'],
  ['NetworkTicket', 'Network ticket'],
  ['ProfilacticSettings', 'Nastavenia servisnej profylaktiky'],
  ['Colocation', 'Kolokácia'],
  ['ColocationSettings', 'Nastavenia kolokácie'],
  ['PredefinedText', 'Preddefinované texty'],
]);
